<template>
    <div class="ppe-shipments">
        <b-button variant="link" class="ppe-shipments__toggle" :aria-expanded="expanded" :aria-controls="`ppe-shipments-${employeeId}`" @click="toggle">
            <i :class="expanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right'" aria-hidden="true"></i>
            Отправлено сотруднику
        </b-button>
        <div v-if="expanded" :id="`ppe-shipments-${employeeId}`">
            <p class="small text-muted mt-2">По отгрузкам в заявках. Дата — последняя отгрузка позиции.</p>
            <div v-for="row in items" :key="row.item_id" class="ppe-shipments__row">
                <strong>{{ row.item_name }}</strong>
                <div v-if="row.quantity !== null">Отправлено: {{ row.quantity }} {{ row.unit }}<span v-if="row.partial" class="text-muted"> из {{ row.planned_quantity }}</span></div>
                <div v-else class="text-warning">Частичная отгрузка: количество для сотрудника не уточнено. В заявке для него — {{ row.planned_quantity }} {{ row.unit }}.</div>
                <small v-if="sizesText(row)" class="d-block text-muted">{{ sizesText(row) }}</small>
                <div class="ppe-shipments__meta">
                    <span v-if="row.shipped_at">{{ formatDate(row.shipped_at) }} · {{ elapsed(row.shipped_at) }}</span>
                    <span v-else>Дата отправки не указана</span>
                    <router-link v-if="row.request_id" :to="`/requests/${row.request_id}`">Заявка {{ row.request_number }}</router-link>
                    <span v-else>Заявка {{ row.request_number }}</span>
                </div>
            </div>
            <p v-if="loaded && !items.length && !error" class="text-muted mb-0">Отправок по заявкам пока нет.</p>
            <div v-if="loading" class="small text-muted py-2" role="status">Загрузка отправок…</div>
            <div v-if="error" class="small text-danger" role="alert">{{ error }} <b-button size="sm" variant="link" @click="load(nextOffset || 0)">Повторить</b-button></div>
            <b-button v-if="!loading && !error && nextOffset !== null" size="sm" variant="link" @click="load(nextOffset)">Показать ещё</b-button>
            <b-button v-if="loaded && !loading && !error" size="sm" variant="link" @click="load(0)">Обновить</b-button>
        </div>
    </div>
</template>

<script>
import api from '@/utils/api';
import {SIZE_LABELS} from '@/utils/requestPpe';
export default {
    name: 'EmployeePpeShipments',
    props: {employeeId: {type: [String, Number], required: true}, contextParams: {type: Object, default: () => ({})}},
    data() { return {expanded: false, loaded: false, loading: false, items: [], nextOffset: null, error: '', version: 0, now: Date.now()}; },
    watch: {
        employeeId() { this.reset(); },
        contextParams: {deep: true, handler() { this.reset(); }}
    },
    beforeDestroy() { this.version++; },
    methods: {
        reset() { this.version++; this.expanded = false; this.loaded = false; this.loading = false; this.items = []; this.nextOffset = null; this.error = ''; },
        toggle() { this.expanded = !this.expanded; this.now = Date.now(); if (this.expanded && !this.loaded && !this.loading) this.load(0); },
        async load(offset = 0) {
            if (this.loading) return;
            const version = ++this.version;
            this.loading = true; this.error = '';
            try {
                const response = await api.get(`/api/employees/${encodeURIComponent(this.employeeId)}/ppe-shipments`, {params: {...this.contextParams, offset}, ignoreModal: true});
                if (version !== this.version) return;
                this.items = offset ? this.items.concat(response.data.items) : response.data.items;
                this.nextOffset = response.data.next_offset;
                this.loaded = true; this.now = Date.now();
            } catch (error) {
                if (version === this.version) this.error = 'Не удалось загрузить отправки.';
            } finally { if (version === this.version) this.loading = false; }
        },
        formatDate(value) { return new Date(value).toLocaleDateString('ru-RU'); },
        elapsed(value) {
            const date = new Date(value), today = new Date(this.now);
            const days = Math.max(0, Math.floor((Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()) - Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())) / 86400000));
            if (!days) return 'сегодня';
            const last = days % 10, teen = days % 100;
            const word = last === 1 && teen !== 11 ? 'день' : (last >= 2 && last <= 4 && (teen < 12 || teen > 14) ? 'дня' : 'дней');
            return `${days} ${word} назад`;
        },
        sizesText(row) { return (row.sizes || []).map(sizes => Object.keys(sizes).map(field => `${SIZE_LABELS[field]}: ${sizes[field]}`).join(' · ')).filter(Boolean).join('; '); }
    }
};
</script>

<style scoped>
.ppe-shipments { border-top: 1px solid #e1e7ed; margin-top: 16px; padding-top: 10px; }
.ppe-shipments__toggle { padding: 0; color: #365d7b; font-weight: 600; font-size: .85rem; text-align: left; }
.ppe-shipments__toggle i { width: 16px; font-size: .65rem; }
.ppe-shipments__row { padding: 10px 0; border-bottom: 1px solid #edf0f3; font-size: .8rem; overflow-wrap: anywhere; }
.ppe-shipments__meta { display: flex; flex-wrap: wrap; gap: 4px 12px; color: #6f7f8d; font-size: .75rem; margin-top: 5px; }
</style>
